import { Pipe, PipeTransform } from '@angular/core';
import { DateEntryMeta, TodesWegzugsDatum } from '../../../core/personstamm-api';

@Pipe({
  name: 'dayMonthYearDate'
})
export class DayMonthYearDatePipe implements PipeTransform {
  transform(value: DateEntryMeta | TodesWegzugsDatum): string {
    if (!value) {
      return '';
    }
    const day = value.day ? value.day : 0;
    const month = value.month ? value.month : 0;
    const year = value.year ? value.year : 0;
    if (day === 0 && month === 0) {
      return String(year).padStart(4, '0');
    }
    return `${String(day).padStart(2, '0')}.${String(month).padStart(2, '0')}.${String(year).padStart(4, '0')}`;
  }
}
